import { atom } from 'jotai'

export const loaderCountAtom = atom(0);

export const globalLoaderAtom = atom(
    (get) => get(loaderCountAtom) > 0,
    (get, set, val) => {
        const count = get(loaderCountAtom);
        set(loaderCountAtom, val ? count + 1 : Math.max(0, count - 1));
    }
);

export const alertAtom = atom({ show: false, msg: '', nextId: '' })